import React, { useState, useRef } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./Dashboard.css";
import { AiOutlineCamera, AiOutlineClose } from "react-icons/ai";
import { apiBaseURL } from "../../../utils/axios";
import { dispatchUser } from "../../../utils/redux/userSlice";
import { ImSpinner9 } from "react-icons/im";
import nigeriaStates from "../../auth/nigeriaStates.json";
import { Helmet } from "react-helmet";

const DashboardEdit = ({ handleToggles }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const token = useSelector((state) => state.user.token);
  const userId = useSelector((state) => state.user.userId);

  const [firstname, setFirstname] = useState(user?.firstname);
  const [lastname, setLastname] = useState(user?.lastname);
  const [phone, setPhone] = useState(user?.phone);
  const [address, setAddress] = useState(user?.donorLocation);
  const [stateValue, setStateValue] = useState(
    user?.state ? user.state.toLowerCase().trim() : ""
  );
  const [city, setCity] = useState(user?.city);
  const [profilePicture, setProfilePicture] = useState(user?.avater);
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  const imgErrorRef = useRef(null);

  // handle Picture Upload
  const handleUpload = async (e) => {
    e.preventDefault();
    setImageLoading(true);

    try {
      const file = e.target.files[0];

      const fileSize = e.target.files[0].size;

      if (fileSize > 500000) {
        Swal.fire({
          icon: "info",
          text: "Profile Image must be below 500KB",
        });
        setImageLoading(false);

        return false;
      } else if (file) {
        const newImage = new FormData();
        newImage.append("file", file);
        newImage.append("upload_preset", "ribiBlood");

        axios
          .post(
            "https://api.cloudinary.com/v1_1/ribi-blood/image/upload",
            newImage
          )
          .then((res) => {
            setProfilePicture(res.data.url);
            setImageLoading(false);
          });
      }
    } catch (error) {
      setImageLoading(false);
      console.error(error);
    }
  };

  // Handles Form Submission

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const userData = {
      firstname: firstname ? firstname : user?.firstname,
      lastname: lastname ? lastname : user?.lastname,
      phone: phone ? phone : user?.phone,
      donorLocation: address ? address : user?.address,
      state: stateValue,
      city: city ? city : user?.city,
      avater: profilePicture ? profilePicture : user?.profilePicture,
    };

    try {
      const response = await axios.put(
        `${apiBaseURL}/v1/donors/${userId}`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(dispatchUser(response.data.user));
      setLoading(false);
      return Swal.fire({
        icon: "success",
        title: "Profile Updated",
        text: "Your Profile is updated",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
          return handleToggles();
        }
      });
    } catch (error) {
      setLoading(false);

      return Swal.fire({
        icon: "info",
        title: "Network Connection Error",
        text: `Try again`,
      });
    }
  };

  if (!token) {
    navigate("/home");
  } else {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Dashboard | RIBI BLOOD</title>
        </Helmet>

        <section className="fixed w-screen h-screen flex items-center bottom-0 right-0 top-0 left-0 overflow-x-hidden overflow-y-hidden z-[100] bg-black/50 justify-center ">
          <div className="rounded-lg w-[90%] sm:w-[70%] lg:w-1/2 relative my-40 lg:my-[112px] bg-blue-100 mx-auto p-5 text-current">
            <button
              className="absolute cursor-pointer top-4 right-6 text-pryclr"
              onClick={handleToggles}
            >
              <AiOutlineClose color="black" size={30} />
            </button>
            <div className="relative">
              <div className="">
                <p className="my-4 text-[18px] lg:text-2xl font-bold text-center lg:my-8">
                  Edit Profile
                </p>
                <div className="max-w-[600px] mx-auto lg:h-auto scrolled flex flex-col justify-center items-center">
                  <form className="w-full lg:h-auto z-50 scrolled">
                    <div className="relative flex justify-center items-center my-4">
                      <img
                        src={
                          !profilePicture
                            ? "https://cdn.pixabay.com/photo/2018/11/13/21/43/instagram-3814049_960_720.png"
                            : profilePicture
                        }
                        alt={user.firstname}
                        onError={(event) => {
                          event.target.src =
                            "https://cdn.pixabay.com/photo/2018/11/13/21/43/instagram-3814049_960_720.png";
                          event.onerror = null;
                        }}
                        className="w-24 h-24 rounded-full opacity-75 border-black object-fill"
                      />
                      <div className="fileContent w-24 h-24 rounded-full">
                        {imageLoading && imgErrorRef.current.value !== "" && (
                          <ImSpinner9
                            size={40}
                            className="animate-spin absolute backdrop-brightness-50-sm z-40 text-red-600"
                          />
                        )}
                        <label className="text-[10px] text-center  cursor-pointer">
                          <AiOutlineCamera className="text-[24px] text-slate-500" />
                          <input
                            style={{ display: "none" }}
                            ref={imgErrorRef}
                            type="file"
                            accept="image/*, capture=camera "
                            onChange={handleUpload}
                          />
                          <br />
                          <span id="imageName"></span>
                        </label>
                      </div>
                    </div>
                    <div className="flex gap-x-6 flex-col my-2 gap-y-2 lg:flex-row lg:items-center lg:gap-x-8 lg:flex lg:justify-between ">
                      <label className="flex-1">Firstname</label>
                      <input
                        className="px-4 py-2 outline-none rounded-lg flex-1"
                        type="text"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                      />
                    </div>
                    <div className="flex gap-x-6 flex-col my-2 gap-y-2 lg:flex-row lg:items-center lg:gap-x-8 lg:flex lg:justify-between ">
                      <label className="flex-1">Lastname</label>
                      <input
                        className="px-4 py-2 outline-none rounded-lg flex-1"
                        type="text"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                      />
                    </div>
                    <div className="flex gap-x-6 flex-col my-2 gap-y-2 lg:flex-row lg:items-center lg:gap-x-8 lg:flex lg:justify-between ">
                      <label className="flex-1">Phone</label>
                      <input
                        className="px-4 py-2 outline-none rounded-lg flex-1"
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>

                    <div className="flex gap-x-6 flex-col my-2 gap-y-2 lg:flex-row lg:items-center lg:gap-x-8 lg:flex lg:justify-between ">
                      <label className="flex-1">Donor Location</label>
                      <input
                        className="px-4 py-2 outline-none rounded-lg flex-1"
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </div>
                    <div className="flex gap-x-6 flex-col my-2 gap-y-2 lg:flex-row lg:items-center lg:gap-x-8 lg:flex lg:justify-between ">
                      <label className="flex-1">State</label>

                      <select
                        className="px-4 py-2 outline-none rounded-lg capitalise bg-white w-full flex-1"
                        value={stateValue}
                        onChange={(e) => {
                          setStateValue(e.target.value.toLowerCase().trim());
                        }}
                      >
                        {" "}
                        <option value="">Select a state</option>
                        {nigeriaStates.map((option) => (
                          <option
                            key={option.id}
                            value={option.name.toLowerCase().trim()}
                            className="capitalize"
                          >
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex gap-x-6 flex-col my-2 gap-y-2 lg:flex-row lg:items-center lg:gap-x-8 lg:flex lg:justify-between ">
                      <label className="flex-1">City</label>
                      <input
                        className="px-4 py-2 outline-none rounded-lg capitalize flex-1"
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </div>
                    <div className="my-5 ">
                      {loading ? (
                        <button className="lg:block md:block px-6 py-2 rounded-full bg-gray-500 font-bold text-black w-full cursor-not-allowed">
                          Updating...
                        </button>
                      ) : (
                        <button
                          onClick={handleSubmit}
                          className="lg:block md:block px-6 py-2 rounded-full bg-red-500 font-bold text-white hover:bg-red-600 w-full cursor-pointer"
                        >
                          Update
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
};

export default DashboardEdit;
